import { AxiosResponse } from 'axios';
import { ApiService } from 'services';
import {
    GetKidsCourses,
    GetKidsCourseSettings,
    KidsCourse,
    KidsCoursesSettings,
    Paging,
} from 'types';
import { urlEncodeUtil } from 'utils';

export class KidsCourseApi extends ApiService {
    getList(
        params: GetKidsCourses
    ): Promise<AxiosResponse<Paging<KidsCourse>>> {
        return this.request<Paging<KidsCourse>>({
            method: 'GET',
            url: '/KidCourse/GetItems',
            params,
            paramsSerializer: urlEncodeUtil,
        });
    }

    getSettings(
        params: GetKidsCourseSettings
    ): Promise<AxiosResponse<KidsCoursesSettings>> {
        return this.request<KidsCoursesSettings>({
            method: 'GET',
            url: '/KidCourse/Get',
            params,
        });
    }
}
